/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Next_7_DaysInputs */

const en_admin_dashboard_next_7_days = /** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next 7 days`)
};

const de_admin_dashboard_next_7_days = /** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste 7 Tage`)
};

const es_admin_dashboard_next_7_days = /** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos 7 días`)
};

const fr_admin_dashboard_next_7_days = /** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 prochains jours`)
};

/** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */
const it_admin_dashboard_next_7_days = en_admin_dashboard_next_7_days;

/** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */
const pt_br2_admin_dashboard_next_7_days = en_admin_dashboard_next_7_days;

/** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */
const pl_admin_dashboard_next_7_days = en_admin_dashboard_next_7_days;

/** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */
const hu_admin_dashboard_next_7_days = en_admin_dashboard_next_7_days;

/** @type {(inputs: Admin_Dashboard_Next_7_DaysInputs) => LocalizedString} */
const ro_admin_dashboard_next_7_days = en_admin_dashboard_next_7_days;

/**
* | output |
* | --- |
* | "Next 7 days" |
*
* @param {Admin_Dashboard_Next_7_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_next_7_days = /** @type {((inputs?: Admin_Dashboard_Next_7_DaysInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Next_7_DaysInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_next_7_days(inputs)
	if (locale === "de") return de_admin_dashboard_next_7_days(inputs)
	if (locale === "es") return es_admin_dashboard_next_7_days(inputs)
	if (locale === "fr") return fr_admin_dashboard_next_7_days(inputs)
	if (locale === "it") return it_admin_dashboard_next_7_days(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_next_7_days(inputs)
	if (locale === "pl") return pl_admin_dashboard_next_7_days(inputs)
	if (locale === "hu") return hu_admin_dashboard_next_7_days(inputs)
	return ro_admin_dashboard_next_7_days(inputs)
});
export { admin_dashboard_next_7_days as "admin.dashboard.next_7_days" }